import React from "react"
import Layout from "../components/Layout"
import SEO from "../components/SEO"
import { graphql } from "gatsby"
import Title from "../components/Title"
import Image from "gatsby-image"
import Jobs from "../components/Jobs"
 const About = ({data:{
                    profileData,
                      },
                    } ) => {

          const {bio, skills, avatar} = profileData

 return (<Layout>
   <SEO title="About | Nishant Tiwari" />
   <section className="about-page">

     <div className="section-center about-center">

       {avatar && avatar.childImageSharp && (
         <Image fluid={avatar.childImageSharp.fluid} className="about-img"/>
       )}

       <article className="about-text">

         <Title title="about me"/>

         <p> {bio} </p>

         <div className="about-stack">
            {skills.map((item, index) => {
              return <span key={index}>{item.name}</span>
            })}

         </div>

       </article>

     </div>

   </section>
   <Jobs featured="true"/>
 </Layout>)
 }


export const query = graphql`
  {
    profileData {
      bio
      skills {
        name
      }
      avatar {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  }
`


export default About
